import { render, staticRenderFns } from "./Departments.vue?vue&type=template&id=11e6c9b6&scoped=true"
import script from "./Departments.vue?vue&type=script&lang=js"
export * from "./Departments.vue?vue&type=script&lang=js"
import style0 from "./Departments.scss?vue&type=style&index=0&id=11e6c9b6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e6c9b6",
  null
  
)

export default component.exports